import {
  MarkEmailReadRounded,
  SupervisedUserCircleRounded,
  VpnLockRounded,
  WorkHistoryOutlined,
} from '@mui/icons-material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

export enum PEOPLE_DETAIL_TAB_KEYS {
  overview = 'overview',
  company_related = 'company_related',
  people_related = 'people_related',
  alerts = 'alerts',
  email_validation = 'email_validation',
}

export const PEOPLE_DETAIL_TABS: ITabSetting[] = [
  {
    key: PEOPLE_DETAIL_TAB_KEYS.overview,
    label: 'OVERVIEW',
    icon: AssignmentIndIcon,
  },
  {
    key: PEOPLE_DETAIL_TAB_KEYS.company_related,
    label: 'Related Companies',
    icon: WorkHistoryOutlined,
  },
  {
    key: PEOPLE_DETAIL_TAB_KEYS.people_related,
    label: 'RELATED PEOPLE',
    icon: SupervisedUserCircleRounded,
  },
  {
    key: PEOPLE_DETAIL_TAB_KEYS.alerts,
    label: 'ALERTS',
    icon: VpnLockRounded,
  },
  {
    key: PEOPLE_DETAIL_TAB_KEYS.email_validation,
    label: 'Email Validation',
    icon: MarkEmailReadRounded,
  },
];
